import(/* webpackMode: "eager" */ "/app/app/indicators/investigator/areas/page.jsx");
